import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {faqs} from '../../variables/faq';

export default function PricingFAQ() {
  return (
    <Grid container direction="column" spacing={4}>
      <Grid>
        <Typography variant="h4" component="h3" gutterBottom align="center">
          Frequently Asked Questions
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" gutterBottom>
          Everything you need to know about our pricing
        </Typography>
      </Grid>
      <Grid>
        {faqs.map((faq) => (
          <Accordion key={faq.question}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Grid>
  );
}
